import "./dashboard";

const MINUTES_IN_A_DAY = 60 * 24;

export function daysToMinutes(numberOfDays: number): number {
  return numberOfDays * MINUTES_IN_A_DAY;
}

export function minutesToDays(numberOfMinutes: number): number {
  return Math.floor(numberOfMinutes / MINUTES_IN_A_DAY);
}

export function isRoundDayInMinutes(numberOfMinutes: number): boolean {
  return numberOfMinutes % MINUTES_IN_A_DAY === 0;
}

export function onlyNumbers(value: string | null | undefined): string | null | undefined {
  if (value != null) {
    return value.replace(/[^\d]+/g, "");
  }
  return value;
}

export const formatMoney = (value: number | null | undefined): string => {
  if (value || value === 0) {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  } else {
    return "";
  }
};

export const emptyToNull = (value: string | null): string | null => {
  if (value === "") {
    return null;
  }
  return value;
};
